/* Wubs – scroll-lås för overlays (varukorgslådan, önskelistan, snabbköp, mobilmenyn).

   ⚠️⚠️ LÅSET SITTER PÅ <html>, ALDRIG PÅ <body> (Liam 2026-09-12: "bild blir sticky …
   sen öppnar man cart, så åker bilden upp").

   `position: sticky` klistrar mot sin närmaste SCROLLANDE förfader. Med
   `body { overflow: hidden }` blir body plötsligt en scroll-container – en som inte
   scrollar – så sticky-elementen inuti kan inte längre fastna och faller tillbaka till
   sin statiska plats i flödet. Uppmätt på produktsidan vid scrollY 900:
   produktbilden hoppade från top 125 till **top −750**, alltså 875 px upp, och tillbaka
   när lådan stängdes. Med låset på <html> förblir viewporten sticky-elementens scrollport
   och hoppet är 0.

   ⚠️ Att låsa <html> tar däremot bort sidans scrollbar, vilket breddar innehållet på
   plattformar med KLASSISKA scrollbars (Windows, Linux). Därför kompenseras bredden med
   padding-right. På macOS overlay-scrollbars är den 0 och ingenting händer.

   ⚠️ DJUPRÄKNARE: snabbköpspanelen stänger sig själv samtidigt som varukorgslådan öppnas.
   Utan räknare hade den stängandes `slapp()` låst upp sidan bakom den öppnande lådan.

   API:  WubsScroll.las()   – lås (kan nästlas)
         WubsScroll.slapp() – släpp ett lås
         WubsScroll.slapp(true) – nollställ oavsett djup (nödutgång)
*/
(function () {
  'use strict';
  var doc = document.documentElement;
  var djup = 0;
  var sparadPadding = '';
  var sparadOverflow = '';

  function las() {
    if (djup++ > 0) return;
    sparadOverflow = doc.style.overflow;
    sparadPadding = doc.style.paddingRight;
    var scrollbar = window.innerWidth - doc.clientWidth;
    if (scrollbar > 0) doc.style.paddingRight = scrollbar + 'px';
    doc.style.overflow = 'hidden';
    doc.setAttribute('data-wubs-last', '');
  }

  function slapp(tvinga) {
    if (tvinga) djup = 0;
    else if (--djup > 0) return;
    if (djup < 0) djup = 0;
    doc.style.overflow = sparadOverflow;
    doc.style.paddingRight = sparadPadding;
    doc.removeAttribute('data-wubs-last');
  }

  window.WubsScroll = { las: las, slapp: slapp };
})();
